/**
 * @example
 * formatSenceRut('123456789') // '12345678-9'
 * formatSenceRut('123.456.789') // '12345678-9'
 * formatSenceRut('12345678-9') // '12345678-9'
 * formatSenceRut('123-456-789') // '12345678-9'
 * formatSenceRut('123-456-78k') // '12345678-k'
 */

export const formatSenceRut = (rut: string | number) => {
  const numbers = `${rut}`.match(/\w+/g)
  if (!numbers) return rut
  const number = numbers.join('')
  const first = number.slice(0, -1)
  const last = number.slice(-1)
  return `${first}-${last}`
}

export const isValidSenceRut = (rut: string) => !!rut.match(/^\d{7,8}-\d$/)
